export default [
  {
    path: 'subscribers',
    name: 'offer_typologies',
    children: [
      {
        path: 'duplicate',
        name: 'offeSrubscribersDuplicate',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_ADD',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },

            {
              text: 'offer.subscriber.title',
              pln: 0,
              active: true,
            },
            {
              text: 'action.duplicate',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
      {
        path: 'show',
        name: 'offeSrubscribersShow',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_VIEW',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },
            {
              text: 'offer.subscriber.title',
              pln: 0,
              active: true,
            },
            {
              text: 'action.show',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
      {
        path: 'edit',
        name: 'offeSrubscribersEdit',
        meta: {
          title: 'offer.title',
          pln: 1,
          action: 'OPERATOR_SUBSCRIPTION_EDIT',
          breadcrumb: [
            {
              text: 'action.list',
              to: '/offers',
            },
            {
              text: 'offer.subscriber.title',
              pln: 0,
              active: true,
            },
            {
              text: 'action.edit',
              active: true,
            },
          ],
          backBtn: true,
        },
      },
    ],
  },
]
